import { render } from "./TongKet.vue?vue&type=template&id=0c7c4757&scoped=true"
import script from "./TongKet.vue?vue&type=script&lang=js"
export * from "./TongKet.vue?vue&type=script&lang=js"

import "./TongKet.vue?vue&type=style&index=0&id=0c7c4757&scoped=true&lang=css"

import exportComponent from "/Users/muoitrinh/Documents/Projects/BetmintonApp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c7c4757"]])

export default __exports__